import { Tooltip } from '@mui/material';

interface SignalLevelProps {
    rssi: number;
    size?: number;
}

// RSSI -> 0..4 bars
function getBars(rssi: number): number {
    if (rssi >= -55) return 4;
    if (rssi >= -65) return 3;
    if (rssi >= -75) return 2;
    if (rssi >= -85) return 1;
    return 0;
}

const TOTAL_BARS = 4;

export default function SignalLevel({ rssi, size = 32 }: SignalLevelProps) {
    if (rssi > -80) return null;

    const bars = getBars(rssi);
    const dimColor = 'rgba(128,128,128,0.3)';

    const barW = size * 0.16;
    const gap = size * 0.07;
    const totalW = TOTAL_BARS * barW + (TOTAL_BARS - 1) * gap;
    const svgH = size * 0.75;

    return (
        <Tooltip title={`rssi: ${rssi}`} arrow>
            <svg
                width={totalW}
                height={svgH}
                viewBox={`0 0 ${totalW} ${svgH}`}
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'block', cursor: 'default' }}
            >
                {Array.from({ length: TOTAL_BARS }, (_, i) => {
                    const barH = svgH * ((i + 1) / TOTAL_BARS);
                    const x = i * (barW + gap);
                    const y = svgH - barH;
                    const filled = i < bars;
                    return (
                        <rect
                            key={i}
                            x={x}
                            y={y}
                            width={barW}
                            height={barH}
                            rx={barW * 0.25}
                            ry={barW * 0.25}
                            fill={filled ? 'currentColor' : dimColor}
                        />
                    );
                })}
            </svg>
        </Tooltip>
    );
}
